import { render, staticRenderFns } from "./TaxReturnReturnReserveSection.vue?vue&type=template&id=2fe89b2c&scoped=true&"
import script from "./TaxReturnReturnReserveSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnReturnReserveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe89b2c",
  null
  
)

export default component.exports